import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { SendAdharOTPServices } from "../../services/index";
import { setAdharMsg } from "../../redux/slices/abhaSlice";
import AlreadyAbhaNumber from "../Already-abhanumber/already-abhanumber";
import { toast } from "react-toastify";
import { Eye, EyeOff } from "lucide-react";
import { setGlobalCurrentStep } from "../../redux/slices/abhaSlice";
const SendAdharOTP = ({
  setAdharNumber,
  setSendOtpFunction,
  setPatient1,
  setCurrentStep,
}) => {
  const [checkbox1Checked, setCheckbox1Checked] = useState(false);
  const [checkbox2Checked, setCheckbox2Checked] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const [inputs, setInputs] = useState({
    input1: "",
    input2: "",
    input3: "",
  });
  const [aNumber, seaNumber] = useState("");
  const [alreadyAbhaNumber, setAlreadyAbhaNumber] = useState(false);
  const dispatch = useDispatch();
  const globalCurrentStep = useSelector(
    (state) => state.user.globalCurrentStep
  );

  const handleAlreadyAbhaNumber = () => {
    // setAlreadyAbhaNumber(true);
    dispatch(setGlobalCurrentStep("AlreadyAbhaNumber"));
  };

  const moveToNextInput = (nextInputId) => {
    const currentInput = document.activeElement;
    if (currentInput.value.length === 4) {
      document.getElementById(nextInputId).focus();
    }
  };
  const handleBackspace = (event, prevInputId) => {
    const currentInput = document.activeElement;
    if (currentInput.value === "" && event.key === "Backspace") {
      document.getElementById(prevInputId).focus();
    }
  };
  const aadharNumber = aNumber.length > 9;
  const handleInputChange = (event, inputId) => {
    let { value } = event.target;
    value = value.replace(/\D/g, "");

    setInputs((prevState) => {
      const updatedInputs = {
        ...prevState,
        [inputId]: value,
      };
      const aadharinputNumber = `${updatedInputs.input1 || ""}${
        updatedInputs.input2 || ""
      }${updatedInputs.input3 || ""}`;

      seaNumber(aadharinputNumber);

      return updatedInputs;
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const adharNumber = `${inputs.input1}${inputs.input2}${inputs.input3}`;
    localStorage.setItem("lastAadharnumber", inputs.input3);
    if (adharNumber.length === 12) {
      if (adharNumber) {
        SendAdharOtp(adharNumber);
      } else {
        alert("Please enter a valid 4-digit OTP.");
      }
    }
  };

  const SendAdharOtp = async (adharNumber) => {
    try {
      const body = {
        aadhaarNumber: adharNumber,
      };
      localStorage.setItem("aadhaarNumber", adharNumber);
      const response = await SendAdharOTPServices({ body });
      console.log(response);
      console.log("111111111");
      if (response.success === false) {
        console.log("22222");
        if (response?.data?.loginId) {
          toast.error("Aadhaar number not registered");
        }
        if (response?.data?.error?.message.includes(":")) {
          const errorMessage = response.data?.error?.message.split(":");
          toast.error(errorMessage[2] || response?.message);
        }
      }
      if (response.status) {
        console.log("OTP sent successfully");
        setAdharNumber(true);
        console.log("OTP sent test");
        const txnId = response.result.txnId;
        const msg = response?.result?.message;
        dispatch(setAdharMsg(msg));
        // setPatient1(false)
        setCurrentStep("VerifyAdhaOtp");
        localStorage.setItem("txnId", txnId);
        const body = { aadhaarNumber: adharNumber };
        setAdharNumber(body);
        // setSendOtpFunction(() => () => SendAdharOtp(adharNumber));
        // if (setSendOtpFunction) {
        //   console.log("setSendOtpFunction is set", adharNumber);
        //   setSendOtpFunction(() => () => SendAdharOtp(adharNumber));
        // }
      }
    } catch (error) {
      console.error("Error while getting token:", error);
      toast.error(error.message);
    }
  };
  // console.log("object", aadharNumber);

  return (
    <>
      <section className="container">
        <div className="abha-create-steps">
          <div className="row">
            <div className="col-md-6">
              <div className="create-abha">
                <h2>Create ABHA Number in 3 Steps</h2>
                <p>
                  Create ABHA and store all your medical records in one place.
                  Take part in the{" "}
                  <span className="highlight">
                    Ayushman Bharat Digital Mission (ABDM)
                  </span>{" "}
                  and get started on your digital health journey.
                </p>

                {/* Steps */}
                <div className="vertical-steps">
                  <div className="step-item">
                    <div className="step-marker">1</div>
                    <div className="step-content">
                      <h4>Verify Aadhaar Details</h4>
                      <p>
                        Enter your Aadhaar number and verify with OTP received
                        on Aadhaar linked mobile number.
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">2</div>
                    <div className="step-content">
                      <h4>Link Mobile Number</h4>
                      <p>
                        Enter your mobile number and verify with OTP to link
                        with ABHA .
                      </p>
                    </div>
                  </div>

                  <div className="step-line" />

                  <div className="step-item">
                    <div className="step-marker">3</div>
                    <div className="step-content">
                      <h4>Create ABHA</h4>
                      <p>Create your ABHA Number with a unique ABHA .</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Right Form Card */}
            {globalCurrentStep === "AlreadyAbhaNumber" ? (
              <AlreadyAbhaNumber />
            ) : (
              <div className="col-md-6">
                <div className="form-card content">
                  <h3>Enter Aadhaar Details to Create/Link ABHA</h3>
                  <div className="d-flex justify-content-between">
                    <p className="pt-3">
                      OTP Will Be Sent to The Mobile Number Linked
                    </p>
                    {showPassword ? (
                      <Eye
                        className="eye-icon"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    ) : (
                      <EyeOff
                        className="eye-icon"
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    )}
                  </div>
                  <form onSubmit={handleSubmit} className="pt-3" autoComplete="off">
                    {/* <div className="col-ms-12 col-lg-12 col-xl-12 col-sm-12 col-xs-12"> */}
                    <div className="aadhar-input d-flex justify-center pt-1">
                      <input
                        className="adhar-input text-center"
                        type={showPassword ? "text" : "password"}
                        maxLength="4"
                        pattern="[0-9]{4}"
                        title="Please enter 4 digits"
                        placeholder="XXXX"
                        id="input1"
                        // autoComplete="off"
                         autoComplete="new-password"
                        onInput={() => moveToNextInput("input2")}
                        value={inputs.input1}
                        onChange={(event) => handleInputChange(event, "input1")}
                        required
                        inputMode="numeric"
                      />
                      <input
                        className="adhar-input text-center ms-3"
                        type={showPassword ? "text" : "password"}
                        maxLength="4"
                        pattern="[0-9]{4}"
                        title="Please enter 4 digits"
                        placeholder="XXXX"
                        id="input2"
                        autoComplete="off"
                        onInput={() => moveToNextInput("input3")}
                        onKeyDown={(event) => handleBackspace(event, "input1")}
                        value={inputs.input2}
                        onChange={(event) => handleInputChange(event, "input2")}
                        required
                        inputMode="numeric"
                      />
                      <input
                        className="adhar-input text-center ms-3"
                        type={showPassword ? "text" : "password"}
                        maxLength="4"
                        pattern="[0-9]{4}"
                        title="Please enter 4 digits"
                        placeholder="XXXX"
                        id="input3"
                        autoComplete="off"
                        onKeyDown={(event) => handleBackspace(event, "input2")}
                        value={inputs.input3}
                        onChange={(event) => handleInputChange(event, "input3")}
                        required
                        inputMode="numeric"
                      />
                    </div>

                    {/* </div> */}
                    <div className="d-flex mt-3">
                      <input
                        type="checkbox"
                        className="form-check-input checkbox-color my-2"
                        id="flexCheckDefault"
                        checked={checkbox1Checked}
                        autoComplete="off"
                        onChange={() => setCheckbox1Checked(!checkbox1Checked)}
                      />
                      <label
                        className="form-check-label ps-2 my-2"
                        htmlFor="flexCheckDefault"
                      >
                        I agree to{" "}
                        <a
                          className="resend-otp"
                          href="https://www.lalpathlabs.com/term-of-use"
                          target="_blank"
                        >
                          Terms & Conditions
                        </a>{" "}
                        and{" "}
                        <a
                          className="resend-otp"
                          href="https://www.lalpathlabs.com/privacy-policy"
                          target="_blank"
                        >
                          Privacy Policy
                        </a>{" "}
                        Lal Path Labs to Create/Link my ABHA.
                      </label>
                    </div>
                    <div className="d-flex">
                      <input
                        type="checkbox"
                        className="form-check-input checkbox-click"
                        id="flexCheckDefaultNHA"
                        checked={checkbox2Checked}
                        autoComplete="off"
                        onChange={() => setCheckbox2Checked(!checkbox2Checked)}
                      />
                      <label
                        className="form-check-NHA ps-2 mb-2"
                        htmlFor="flexCheckDefaultNHA"
                      >
                        I agree to{" "}
                        <a
                          className="resend-otp"
                          href="/terms-condition"
                          target="_blank"
                        >
                          Terms & Conditions
                        </a>{" "}
                        approved by the NHA{" "}
                      </label>
                    </div>
                    <button
                      type="submit"
                      className={`continue-btn nha-adhar continue-btn ${
                        !aadharNumber || !checkbox1Checked || !checkbox2Checked
                          ? "bg-disable"
                          : ""
                      }`}
                      disabled={
                        !aadharNumber || !checkbox1Checked || !checkbox2Checked
                      }
                    >
                      Continue
                    </button>
                    <button
                      className="already-abha"
                      onClick={handleAlreadyAbhaNumber}
                    >
                      <a style={{color:'#204096',fontWeight:'bold'}}  className="ps-2">
                        I already have Abha Number / ABHA
                      </a>{" "}
                    </button>
                  </form>
                </div>
              </div>
            )}
          </div>
        </div>
      </section>
    </>
  );
};

export default SendAdharOTP;
